module.exports = __webpack_public_path__ + "static/mask-9f39bcfbc772e60aba2904cfb0426137.png";